import { FC } from 'react';
import Tab from './tab';
import ThemeModeControl from '../user-menu/theme-mode-control';
import { Box, Divider, Stack } from '@mui/material';
import TailControl from '../user-menu/tail-control';
import TabHeader from './tab/tab-header';
import TabContent from './tab/tab-content';
import useFeature from '@/hooks/use-feature.hook';

interface Props {
  onClose?: () => void;
}

const PreferencesTab: FC<Props> = ({ onClose }) => {
  const { canUseChat } = useFeature();
  return (
    <Tab onClose={onClose}>
      <TabHeader icon="display-settings" title="Preferences" />
      <Box mt={2}>
        <TabContent>
          <Stack gap={1}>
            <ThemeModeControl inline />
            {canUseChat && (
              <>
                <Divider />
                <TailControl inline />
              </>
            )}
          </Stack>
        </TabContent>
      </Box>
    </Tab>
  );
};

export default PreferencesTab;
